import {Injectable} from '@angular/core';
import {ReportesRequestService} from './request/reportes-request.service';

@Injectable({
  providedIn: 'root'
})
export class ServicioSedesService {

  constructor(private requestUrl: ReportesRequestService) { }

  async getSedesBySede(codigo: string, uncoSede: number) {
    try {
      const request = await this.requestUrl.getFilterRequest(
        'sede/by-sede',
        [ codigo, { 'sede' : uncoSede }]
      );
      return request;
    } catch(e) {
      console.error(`ServicioSedesService.getSedesBySede() : ${e}`);
    }
    return null;
  }

  async getSedes(codigo: string) {
    try {
      return await this.requestUrl.getFilterRequest(
        'sede/sedes',
        [codigo]
      );
    } catch (e) {
      console.error(`ServicioSedesService.getSedes() : ${e}`);
    }
    return null;
  }

  async getPuntosAtencion(codigo: string, sedes: string) {
    try {
      return await this.requestUrl.getFilterRequest(
        'sede/puntos-atencion-sede',
        [codigo, {sedes}]
      );
    } catch (e) {
      console.error(`ServicioSedesService.getSedes() : ${e}`);
    }
    return null;
  }

}

export interface SedeEntity {
  unco ?: number;
  descripcion ?: string;
}
